import React, { Component } from 'react';
import {
  Button, Card, CardBody, Col, Table, UncontrolledTooltip,
} from 'reactstrap';
import { Link, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import Moment from 'moment';
import swal from 'sweetalert';

import EditInventory from '../../components/BatchUpdateModal';
import CommonService from '../../../../services/CommonService';
import DistributionModals from './DistributionModals';
import global from '../../../../global';

class WarehouseDistribution2 extends Component {
  static propTypes = {
    itemID: PropTypes.string.isRequired,
  };

  constructor(props) {
      super(props);
      this.userdata = JSON.parse(localStorage.getItem('userData'));
      const { itemID } = this.props;
      this.currDate = new Date();
      this.state = {
        list: [],
        modal: false,
        thisLocationID: '',
        inventoryData: {
          productName: 'Product Name',
          grandtotal: '0',
          receiving_report: '0',
          withdrawal_report: '0',
          stock_transfer: '0',
          total_out: '0',
          quantity: '0',
          errorMsg: '',
        },
        formdata: {},
      };
      this.executeModal = '';
      this.control_id = itemID;
      this.isLoading = false;
      this.editToggle = this.editToggle.bind(this);
      this.inventoryMyDate = Moment(this.currDate).format('YYYY-MM-DD');

      if (localStorage.getItem('warehouseInventoryDate') !== null) {
        const storageDate = JSON.parse(localStorage.getItem('warehouseInventoryDate'));
        this.inventoryMyDate = storageDate.date;
      }
  }

  componentDidMount() {
    this.isLoading = true;
    this.onLoadInventory();
  }

  componentWillUnmount() {
    this.isLoading = false;
  }

  onLoadInventory = async () => {
    try {
      const { inventoryData } = this.state;
        const response = await CommonService.getRows(`warehousebatches/controlid/${this.control_id}/inventorydate/${this.inventoryMyDate}`);
        if (response.result !== false) {
            this.setState({
              list: response.list,
              thisLocationID: response.locationid,
              inventoryData: {
                productName: response.product_name,
                grandtotal: (response.grandtotal ? response.grandtotal : inventoryData.grandtotal),
                receiving_report: (response.stock_receive ? response.stock_receive : inventoryData.receiving_report),
                withdrawal_report: (response.stock_out ? response.stock_out : inventoryData.withdrawal_report),
                stock_transfer: (response.stock_transfer ? response.stock_transfer : inventoryData.stock_transfer),
                total_out: (response.total_out ? response.total_out : inventoryData.total_out),
                quantity: (response.stock_balance ? response.stock_balance : inventoryData.quantity),
              },
            });
        }
    } catch (err) {
       console.log('Error: ', err.message);
    }
    this.isLoading = false;
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
       formdata: { ...prevState.formdata, [name]: value },
    }));
  }

  toggleModal = () => {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

  async editSubmitForm(e, batchid) {
    e.preventDefault();
    e.stopPropagation();
    const form = document.getElementById('updateInventory_form');
    const formdata = new FormData(form);
    formdata.append('batchid', batchid);
    formdata.append('inventory_date', this.inventoryMyDate);
    formdata.append('updated_by', this.userdata.user_id);

    try {
      const response = await CommonService.updateData('updatewarehousestock', formdata, false);
        if (response) {
          const { list } = this.state;
          list.filter((listResp) => {
            if (listResp.batch_id === batchid && response.formdata) {
              const formkeys = Object.keys(response.formdata);
              const formvalue = Object.values(response.formdata);
              formkeys.map((item, value) => {
                listResp[item] = formvalue[value];
                return console.log(item, formvalue[value]);
              });
            }
            return listResp;
          });
          this.setState({ list, modal: false });
          swal('', 'Successfully updated user information!', 'success');
        }
   } catch (err) {
      console.log(err.message);
      this.isLoading = false;
   }
  }

  confirmStock(e, invID, sts, quantity = 0) {
    e.preventDefault();
    this.executeModal = 'acceptnewstock';
    this.toggleModal();
    this.setState({
      formdata: {
        inventoryId: invID,
        actualQuantity: quantity,
        note: '',
        status: sts,
      },
    });
    // submit form
    this.handleSubmit = (ev) => { this.submitConfirmation(ev); };
  }

  async submitConfirmation(e) {
    e.preventDefault();
    const {
      formdata, thisLocationID,
    } = this.state;

    formdata.locationId = thisLocationID;
    formdata.added_by = this.userdata.user_id;
      if ((formdata.status === 1 && formdata.actualQuantity) || (formdata.status === 2 && formdata.note)) {
        console.log(formdata);
        this.setState({ errorMsg: '' });
        const result = await CommonService.updateData('updatewarehousestocksstatus', formdata);
        if (result === true) {
          this.setState({ errorMsg: '', modal: false });
          this.onLoadInventory();
        } else {
          this.setState({ modal: false });
          swal('', 'Failed to update information!', 'danger');
        }
      } else {
        this.setState({ errorMsg: 'Required fields are empty.' });
      }
  }

  editToggle(e, batchid) {
    e.preventDefault();
    e.stopPropagation();
    this.executeModal = 'editinventory';
    this.toggleModal('Edit Room');

    this.setState({
        formdata: {
            batch_id: batchid,
        },
    });

    this.handleSubmit = (formEvent) => {
      this.editSubmitForm(formEvent, batchid);
    };
  }

  render() {
      const {
        list, inventoryData, goTo, goToPage, thisLocationID, modal, errorMsg, formdata,
      } = this.state;

      if (goTo === true) {
        return <Redirect to={goToPage} />;
      }

      return (
        <Col md={12}>
        {
          this.executeModal === 'editinventory' ? (
            <EditInventory
                icon="fa fa-plus"
                btn="Edit Room"
                modal={modal}
                handleChange={this.handleChange}
                toggle={this.toggleModal}
                handleSubmit={this.handleSubmit}
                errorMsg={errorMsg}
                postValue={formdata}
                locationID={this.locationID}
                locationType="1"
            />
          ) : this.executeModal === 'acceptnewstock' ? (
              <DistributionModals
                icon="fa fa-plus"
                modal={modal}
                toggle={this.toggleModal}
                postValue={formdata}
                handleChange={this.handleChange}
                handleSubmit={this.handleSubmit}
                errorMsg={errorMsg}
              />
          ) : ''
        }
          <Card className="panel panel--primary" id="users_table">
            <CardBody className="panel__body">
              <div className="panel__title bg_blue">
                <h5 className="bold-text">{inventoryData.productName}</h5>
                <div className="panel__btns">
                  <Link className="rounded text-white btn btn-sm btn-outline-secondary btn-awesome" to={`/inventory/warehouse/dashboard/${thisLocationID}`}>
                    <i className="fa fa-arrow-left" />
                    <span>Back</span>
                  </Link>
                </div>
              </div>
              <div className="panel__content">
                <div className="stock-box__container stock-sm">
                  <div className="stock-box outline stock-green">
                    <div className="stock-box__icon"><i className="fa fa-dolly-flatbed" /></div>
                    <h3 className="stock-box__num">{global.numberFormat(inventoryData.receiving_report)} kgs.</h3>
                    <h4 className="stock-box__text">Receiving Report</h4>
                  </div>
                  <div className="stock-box outline stock-red">
                    <div className="stock-box__icon"><i className="fa fa-truck-loading" /></div>
                    <h3 className="stock-box__num">{global.numberFormat(inventoryData.total_out, 0)} kgs.</h3>
                    <h4 className="stock-box__text">Total Out</h4>
                  </div>
                  <div className="stock-box outline stock-orange">
                    <div className="stock-box__icon"><i className="fa fa-balance-scale" /></div>
                    <h3 className="stock-box__num">{global.numberFormat(inventoryData.quantity)} kgs.</h3>
                    <h4 className="stock-box__text">Stock Balance</h4>
                  </div>
                  <div className="stock-box stock-blue">
                    <div className="stock-box__icon"><i className="fa fa-dollar-sign" /></div>
                    <h3 className="stock-box__num">{global.numberFormat(inventoryData.grandtotal)}</h3>
                    <h4 className="stock-box__text">Grand Total</h4>
                  </div>
                </div>
              </div>
              <div className="panel__content">
                <Table responsive striped className="jns-table">
                    <thead>
                    <tr>
                        <th>Batch Code</th>
                        <th>Product</th>
                        <th>Supplier</th>
                        <th className="text-center">Room #</th>
                        <th className="text-center">Ref #</th>
                        <th className="text-center">Received</th>
                        <th className="text-center">Total Out</th>
                        <th className="text-center">Remaining Stock</th>
                        {
                        this.userdata.type && (this.userdata.type === '1' || this.userdata.type === '4') && (
                          <>
                            <th className="text-center">Unit Cost</th>
                            <th className="text-center">Total</th>
                          </>
                          )
                        }
                        <th className="text-center">Date Received</th>
                        <th className="text-center" width="100px">Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        list !== false || list.length > 0 ? list.map((item, ii) => {
                        const totalTransfer = item.total_transfer && item.total_transfer !== '0' ? global.parseToNumber(item.total_transfer, 'float') : 0;
                        const totalSold = item.total_out && item.total_out !== '0' ? global.parseToNumber(item.total_out, 'float') : 0;
                        const totalOut = totalTransfer + totalSold;
                        const i = global.parseToNumber(ii.toString());

                        return (
                            <tr key={i} className="text-center">
                              <td className="text-left">{item.batch_code ? item.batch_code : '-- : -------- : --'}</td>
                              <td className="text-left">{item.product_name}</td>
                              <td className="text-left">{item.supplier_name}</td>
                              <td>{item.room ? item.room : '-- : -------- : --'}</td>
                              <td>{item.reference_number ? item.reference_number : '-- : -------- : --'}</td>
                              <td>{item.total_in && item.total_in !== '0' ? `${item.total_in} kgs.` : <strong className="text-danger">0</strong>}</td>
                              <td>{totalOut !== 0 ? `${totalOut} kgs.` : <strong className="text-danger">0</strong>}</td>
                              <td>{item.balance_new && item.balance_new !== '0' ? `${item.balance_new} kgs.` : <strong className="text-danger">0</strong>}</td>
                              {
                                this.userdata.type && (this.userdata.type === '1' || this.userdata.type === '4') && (
                                  <>
                                    <td className="text-success">&#x20b1; {item.unit_cost ? item.unit_cost : '-- : -------- : --'}</td>
                                    <td>&#x20b1;{global.numberFormat(item.balance_new * global.parseToNumber(item.unit_cost), 2)}</td>
                                  </>
                                )
                              }
                              <td>{item.date_added ? item.date_added : '-- : -------- : --'}</td>
                              <td>
                                  {
                                    item.pending_stock === '1' ? (
                                      <span>
                                        {/* Approve button */}
                                        <Button color="success" className="btn-xs" title="Approve" onClick={e => this.confirmStock(e, item.entry_id, 1, item.total_in)} id={`approvebtn${i + 1}`} outline><span className="fa fa-check" /></Button>
                                        <UncontrolledTooltip placement="bottom" target={`approvebtn${i + 1}`}>Approve</UncontrolledTooltip>
                                        {/* Deny button */}
                                        <Button color="danger" className="btn-xs" title="Deny" onClick={e => this.confirmStock(e, item.entry_id, 2, item.total_in)} id={`denybtn${i + 1}`} outline><span className="fa fa-times" /></Button>
                                        <UncontrolledTooltip placement="bottom" target={`denybtn${i + 1}`}>Deny</UncontrolledTooltip>
                                      </span>
                                    ) : (
                                      <span>
                                        <Button color="primary" className="btn-xs" onClick={e => this.editToggle(e, item.batch_id)} id={`editbtn${i + 1}`} outline><span className="lnr lnr-pencil" /></Button>
                                      </span>
                                    )
                                  }
                              </td>
                            </tr>
                        );
                        }) : (
                        <tr className="text-center">
                            <td colSpan="12">No data available..</td>
                        </tr>
                        )
                    }
                    </tbody>
                </Table>
              </div>
            </CardBody>
          </Card>
        </Col>
      );
  }
}

export default withTranslation('common')(WarehouseDistribution2);
